import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div<{ $size?: number }>`
  width: ${({ $size = 32 }) => $size}px;
  height: ${({ $size = 32 }) => $size}px;
  border: 3px solid var(--gray-200);
  border-top-color: var(--primary-600);
  border-radius: 50%;
  animation: ${rotate} 0.8s linear infinite;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-md);
  padding: var(--space-2xl) var(--space-md);
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
`;

interface LoadingStateProps {
  /** Testo sotto lo spinner; default "Caricamento..." */
  label?: string;
  size?: number;
}

/** Stato di caricamento standard, centrato nel contenitore. */
export const LoadingState: React.FC<LoadingStateProps> = ({ label = 'Caricamento...', size = 32 }) => (
  <Wrapper role="status" aria-live="polite">
    <Spinner $size={size} />
    <span>{label}</span>
  </Wrapper>
);

export default Spinner;
